import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { FiArrowRight, FiShoppingCart } from 'react-icons/fi';

const Hero = () => {
  return (
    <section className="w-full py-24 md:py-32 px-6 bg-white border-b-4 border-black relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-10 right-10 w-32 h-32 border-4 border-black rounded-full opacity-10 pointer-events-none"></div>
      <div className="absolute bottom-10 left-10 w-24 h-24 border-4 border-black opacity-10 pointer-events-none rotate-45"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 border-2 border-black px-4 py-1 mb-8 font-bold text-sm brutal-shadow-sm bg-[#f0f0f0]">
          <SafeIcon icon={FiShoppingCart} className="w-4 h-4" />
          ETERA.STORE — THE PERMANENT QR SHOP
        </div>
        
        <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[1.1] mb-8">
          The Only QR Code <br />
          <span className="bg-black text-white px-4 inline-block mt-2 transform -rotate-1">
            You Ever Need To Buy
          </span>
        </h1>
        
        <p className="text-xl md:text-2xl font-medium mb-12 max-w-2xl mx-auto leading-relaxed">
          Stop renting your links. ETERA is the single destination for permanent, dynamic QR codes. Buy once, own for life, and update your destination URL anytime.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <Link style={{
      color: 'rgb(255, 255, 255)'
    }} 
            to="/dashboard" 
            className="flex items-center gap-2 bg-black text-white border-2 border-black px-8 py-4 font-black text-lg brutal-shadow-lg brutal-hover w-full sm:w-auto justify-center"
          >Get your first code<SafeIcon icon={FiArrowRight} className="w-5 h-5" />
          </Link>
          <a 
            href="#how-it-works" 
            className="flex items-center gap-2 bg-white text-black border-2 border-black px-8 py-4 font-black text-lg brutal-shadow-lg brutal-hover w-full sm:w-auto justify-center"
          >
            How it Works
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;